import range from "lodash/range";

// define months' name for each language
const months: Record<string, Array<string>> = {
  EN: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  CH: [ "一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"],
  ID: [ "Januari", "Februari", "Maret", "April", "Mei", "Juni", "Juli", "Agustus", "Septemer", "Oktober", "November", "Desember"],
  MY: [ "Januari", "Februari", "Mac", "April", "Mei", "Jun", "Julai", "Ogos", "Septemer", "Oktober", "November", "Disember"],
  TH: [ "มกราคม", "กุมภาพันธ์", "มีนาคม", "เมษายน", "พฤษภาคม", "มิถุนายน", "กรกฎาคม", "สิงหาคม", "กันยายน", "ตุลาคม", "พฤศจิกายน", "ธันวาคม"],
  "TH-EN": [ "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
  VN: ["Tháng Một", "Tháng Hai", "Tháng Ba", "Tháng Tư", "Tháng Năm", "Tháng Sáu", "Tháng Bảy", "Tháng Tám", "Tháng Chín", "Tháng Mười", "Tháng Mười Một", "Tháng Mười Hai"]
};

export const dayOptions = range(1, 32).map((it) => ({
  value: it,
  label: it.toString().padStart(2, "0"),
}));

export const getMonthOptions = (
  lang = "EN"
): Array<{ value: number; label: string }> => {
  const allMonths = months[lang];
  if (!allMonths) return [];
  return range(0, 12).map((it) => ({
    value: it,
    label: allMonths[it],
  }));
};

export const getYearOptions = range(1900, new Date().getFullYear() + 1).map(
  (it) => ({
    value: it,
    label: it,
  })
);
